import apiClient from './index';
import { DeviceCountsBreakdown } from './types';

export type BuildingCorpsInDB = {
  id: string;
  name: string;
  building_id: string;
  created_at: string;
  is_default?: boolean;
  device_count?: number;
  device_counts?: DeviceCountsBreakdown | null;
};

export type BuildingCorpsCreate = {
  name: string;
  building_id: string;
};

export type BuildingCorpsUpdate = {
  name: string;
  building_id: string;
};

export const buildingCorpsApi = {
  async getAll(skip: number = 0, limit: number = 100): Promise<BuildingCorpsInDB[]> {
    const res = await apiClient.get<BuildingCorpsInDB[]>('/building-corps/', { params: { skip, limit } });
    return res.data;
  },

  async getByBuilding(buildingId: string): Promise<BuildingCorpsInDB[]> {
    const res = await apiClient.get<BuildingCorpsInDB[]>(`/building-corps/by-building/${buildingId}`);
    return res.data;
  },

  async ensureDefault(buildingId: string): Promise<BuildingCorpsInDB> {
    const res = await apiClient.post<BuildingCorpsInDB>(
      `/building-corps/by-building/${buildingId}/ensure-default`
    );
    return res.data;
  },

  async create(data: BuildingCorpsCreate): Promise<BuildingCorpsInDB> {
    const res = await apiClient.post<BuildingCorpsInDB>('/building-corps/', data);
    return res.data;
  },

  async getById(corpsId: string): Promise<BuildingCorpsInDB> {
    const res = await apiClient.get<BuildingCorpsInDB>(`/building-corps/${corpsId}`);
    return res.data;
  },

  async update(corpsId: string, data: BuildingCorpsUpdate): Promise<BuildingCorpsInDB> {
    const res = await apiClient.put<BuildingCorpsInDB>(`/building-corps/${corpsId}`, data);
    return res.data;
  },

  async delete(corpsId: string, force: boolean = false): Promise<void> {
    const suffix = force ? "?force=true" : "";
    await apiClient.delete(`/building-corps/${corpsId}${suffix}`);
  },
};
